var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{staticClass:"text-xs-center",attrs:{"label":'',"color":_vm.localBlocked ? 'red' : ''},on:{"change":_vm.onToggle},model:{value:(_vm.localBlocked),callback:function ($$v) {_vm.localBlocked=$$v},expression:"localBlocked"}})
}
var staticRenderFns = []

export { render, staticRenderFns }